import React from "react";
import { ModalFooter } from "reactstrap";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

type Props = {
    label: string;
    onClose: () => void;
};

export function CloseFooter({ label, onClose }: Props) {
    return (
        <ModalFooter className="border-top-0">
            <CustomMainColorButton
                data-testid="fidelity-active-close-button"
                rounded
                className="mr-2"
                variant="primary"
                onClick={onClose}
            >
                {label}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
